<template>
  <el-select
    v-model="selectID"
    @change="selectChange"
    :multiple="multiple"
    :disabled="disabled"
    filterable
    collapse-tags
    placeholder="请选择">
    <el-option
      v-for="item in dataList"
      :key="item.id"
      :label="item.userName"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>

  export default {
    data() {
      return {
        selectID: this.userId,
        dataList: [],
      }
    },
    props: {
      userId: {
        type: [Number,Array],
        default: null
      },
      multiple: {
        type: Boolean,
        default: true
      },
      disabled: Boolean,
    },
    watch: {
      userId: function (newVal, oldVal) {
        this.selectID = newVal;
      },
      selectID : function(newVal, oldVal){
        this.$emit("update:userId", newVal);
      }
    },
    created() {
      this.getDataList();
    },
    methods: {
      selectChange(event, item) {
        this.$emit('select', event, item);
      },
      getDataList() {
        this.$http({
          url: this.$http.adornUrl('/sys/user/select'),
          method: 'get',
          params: this.$http.adornParams()
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.data
          } else {
            this.dataList = []
          }
        }).catch((err) => {
          console.log(err);
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/user-select.vue